import { render, staticRenderFns } from "./Volumes.vue?vue&type=template&id=59841f0c"
import script from "./Volumes.vue?vue&type=script&lang=js"
export * from "./Volumes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports